import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootprintApiManager_ds_flatten_data_source_example_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async get($inParams: {  }): Promise<{ result?: { Reduce?: { LookupCode?: string, Packaging?: string, GrossWeight?: number, NetWeight?: number, WeightUom?: string, IsBase?: boolean, BasePackaging?: string }[], Map?: { LookupCode?: string, Packaging?: string, GrossWeight?: number, NetWeight?: number, WeightUom?: string, IsBase?: boolean, BasePackaging?: string }[], ForLoop?: { LookupCode?: string, Packaging?: string, GrossWeight?: number, NetWeight?: number, WeightUom?: string, IsBase?: boolean, BasePackaging?: string }[], Seconds?: { Reduce?: number, Map?: number, ForLoop?: number }, Materials?: number[] } }> {
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = null;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

    
    hasMissingRequiredInParams($inParams: { 
      }) {
      return false;
    }
}
